import { render, staticRenderFns } from "./competitionManagement.vue?vue&type=template&id=2137daab&scoped=true"
import script from "./competitionManagement.vue?vue&type=script&lang=js"
export * from "./competitionManagement.vue?vue&type=script&lang=js"
import style0 from "./competitionManagement.vue?vue&type=style&index=0&id=2137daab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137daab",
  null
  
)

export default component.exports